import { render, staticRenderFns } from "./mould_equipment_tonnage.vue?vue&type=template&id=22c66a40&"
import script from "./mould_equipment_tonnage.vue?vue&type=script&lang=js&"
export * from "./mould_equipment_tonnage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports